import { Theme } from '@mui/material/styles';

export default function Card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: 'relative',
          boxShadow: theme.customShadows.card,
          borderRadius: Number(theme.shape.borderRadius) * 2,
          zIndex: 0, // Fix Safari overflow: hidden with border radius
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        slotProps: {
          title: { variant: 'h6', textAlign: 'center' },
          subheader: { variant: 'body2', marginTop: theme.spacing(0.5) },
        },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3),
          backgroundColor: theme.palette.background.neutral,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
          padding: theme.spacing(3),
        },
      },
    },
  };
}
